import { Reducer } from 'redux';
import { ActionType, getType } from 'typesafe-actions';

import { AuthState } from './Types';

import * as Actions from './Actions';
export type AuthAction = ActionType<typeof Actions>;

const initialState: AuthState = {
    isAuthenticating: false,
    isAuthenticated: false,
    isCreatingNewUser: false,
    isObtainingNewAccessToken: false,
    accessToken: null,
    errorCode: null,
    errorMessage: null,
    exceptionType: null,
    exceptionData: null,
};

const reducer: Reducer<AuthState> = (state = initialState, action: AuthAction) => {
    switch (action.type) {
        case getType(Actions.loginUserRequest):
            return { ...state,
                isAuthenticating: true,
                errorCode: null,
                errorMessage: null,
            };

        case getType(Actions.loginUserSuccess):
            return { ...state,
                isAuthenticating: false,
                isAuthenticated: true,
                isObtainingNewAccessToken: false,
                accessToken: action.payload.accessToken,
                errorCode: null,
                errorMessage: null,
            };

        case getType(Actions.loginUserFailure):
            return { ...state,
                isAuthenticating: false,
                isAuthenticated: true,
                isObtainingNewAccessToken: false,
                accessToken: null,
                errorCode: action.payload.errorCode,
                errorMessage: action.payload.errorMessage,
            };

        case getType(Actions.logoutUserSuccess):
            return { ...state,
                errorCode: null,
                errorMessage: null,
            };
        case getType(Actions.getnewAccessTokenRequest):
            return { ...state,
                isObtainingNewAccessToken: true,
            };

        case getType(Actions.getnewAccessTokenSuccess):
            return { ...state,
                isAuthenticating: false,
                isAuthenticated: true,
                isObtainingNewAccessToken: false,
                accessToken: action.payload.accessToken,
                errorCode: null,
                errorMessage: null,
            };

        case getType(Actions.getnewAccessTokenFailure):
        case getType(Actions.useNewAccessTokenFailure):
            return { ...state,
                isAuthenticating: false,
                isAuthenticated: false,
                isObtainingNewAccessToken: false,
                accessToken: null,
                errorCode: action.payload.errorCode,
                errorMessage: action.payload.errorMessage,
            };
        default:
            return state;
    }
};

export default reducer;
